import { gql } from '@apollo/client';

export const completeGoalsMutation = gql`
  mutation CompleteGoals($skipCompletion: Boolean!) {
    completeGoals(data: { skipCompletion: $skipCompletion }) {
      user {
        id
        collectedCurrency
        goalCompletion
      }
      eventLogs {
        goalCompleted {
          goalId
          currencyEarned
          levelCompleted
        }
      }
    }
  }
`;